export default __webpack_public_path__ + "static/media/Asset 7.515f0a1f.svg";